import { useState, useCallback } from "react";
import { Apis } from "../../lib/Apis";

// --- Hook from ConstructionCalculator/useHook.js ---
export const useConstructionCalculatorHook = () => {
  const addConstructionCalculator = async (data) => {
    try {
      const response = await Apis.addConstructionCalculator(data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const getConstructionCalculators = async (setCalculators, setPagination, offset, limit) => {
    try {
      const response = await Apis.getConstructionCalculators(offset, limit);
      const payload = response?.data;
      // API may return either { data: [...], pagination: {...} } or a legacy nested shape.
      const list = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.data?.data)
          ? payload.data.data
          : [];
      const page = payload?.pagination ?? payload?.data?.pagination ?? null;

      if (setCalculators) setCalculators(list);
      if (setPagination && page) {
        setPagination((prev) => ({
          ...prev,
          ...page,
          // keep current query params driving these
          offset,
          limit,
        }));
      }
      return payload;
    } catch (error) {
      throw error;
    }
  };

  const updateConstructionCalculator = async (id, data) => {
    try {
      const response = await Apis.updateConstructionCalculator(id, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const deleteConstructionCalculator = async (id) => {
    try {
      const response = await Apis.deleteConstructionCalculator(id);
      return response;
    } catch (error) {
      return error;
    }
  };

  return {
    addConstructionCalculator,
    getConstructionCalculators,
    updateConstructionCalculator,
    deleteConstructionCalculator,
  };
};

// --- Hook from OurProjects/useHook.js ---
export const useProjects = () => {

    const getProjectsData = async (setOurProjectsData, id, paginationParams = {}) => {
        try {
            const response = await Apis.getOnTheBasisOfSubCategory(id, paginationParams)
            setOurProjectsData(response.data.data)
            return response.data.pagination
        } catch (error) {
            console.log(error)
        }
    }
    const addProject = async (data) => {
        try {
            const response = await Apis.addProject(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateProject = async (id, data) => {
        try {
            const response = await Apis.updateProject(id, data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const deleteProject = async (id) => {
        try {
            const response = await Apis.deleteProject(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getProjectById = async (id) => {
        try {
            const response = await Apis.getProjectById(id)
            return response.data
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getAllProjectCategories = async (setProjectCategories) => {
        try {
            const response = await Apis.getAllProjectCategories()
            setProjectCategories(response.data.projectCategories)
        } catch (error) {
            console.log(error)
        }
    }
    const getProjectByIdData = async (id, setProjectData) => {
        try {
            const response = await Apis.getProjectById(id)
            setProjectData(response.data.projects[0])
        }
        catch (error) {
            console.log(error)
            throw error
        }
    }
    const getSimilarProjectExpectAdded = async (id, setExpectAdded) => {
        try {
            const response = await Apis.getSimilarProjectExpectAdded(id)
            setExpectAdded(response.data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const postSimilarProject = async (data) => {
        try {
            const response = await Apis.postSimilarProject(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getAddedSimilarProject = async (id, setAddedSimilarProject) => {
        try {
            const response = await Apis.getAddedSimilarProject(id)
            setAddedSimilarProject(response.data.similarProjects)
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const deleteSimilarProject = async (id) => {
        try {
            const response = await Apis.deleteSimilarProject(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateSimilarProjectPosition = async (id, position) => {
        try {
            const response = await Apis.updateSimilarProjectPosition(id, position)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getParentProjectCategories = async (setParentProjectCategories) => {
        try {
            const response = await Apis.getParentProjectCategories()
            setParentProjectCategories(response.data.data)
            return response
        } catch (error) {
            console.log(error)
        }
    }
    const addSubCategory = async (data) => {
        try {
            const response = await Apis.addSubCategory(data)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const updateSubCategory = async (id, data) => {
        try {
            if (data instanceof FormData) {
                data.append('id', id)
                const response = await Apis.updateSubCategory(data)
                return response
            } else {
                const body = {
                    id: id,
                    ...data
                }
                const response = await Apis.updateSubCategory(body)
                return response
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const getSubCategories = async (setSubCategories, paginationParams = {}) => {
        try {
            const response = await Apis.getSubCategories(paginationParams)
            setSubCategories(response.data.data)
            return response.data.pagination
        } catch (error) {
            console.log(error)
        }
    }
    const toggleProjectStatus = async (id) => {
        try {
            const response = await Apis.toggleProjectStatus(id)
            return response
        } catch (error) {
            console.log(error)
            throw error
        }
    }
    const showProjectOnHomeScreen = async (projectId, homeScreen) => {
        try {
            const data = {
                projectId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addProjectToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };
    const updateSubCategoryPosition = async (id, position) => {
        try {
            const response = await Apis.updateSubCategoryPosition(id, position);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
    const updateProjectPosition = async (projectId, newPosition) => {
        try {
            const response = await Apis.updateProjectPosition({ projectId, newPosition });
            return response?.data;
        } catch (error) {
            console.error("Error updating project position:", error);
            throw error;
        }
    };
    return { getProjectsData, addProject, updateProject, deleteProject, getProjectById, getAllProjectCategories, getProjectByIdData, getSimilarProjectExpectAdded, postSimilarProject, getAddedSimilarProject, deleteSimilarProject, updateSimilarProjectPosition, getParentProjectCategories, addSubCategory, updateSubCategory, getSubCategories, toggleProjectStatus, showProjectOnHomeScreen, updateSubCategoryPosition, updateProjectPosition }
}

// --- Hook from Services/useHook.js ---
export const useServices = () => {
  const [loading, setLoading] = useState(false);

  const getServices = useCallback(async (
    setServiceData,
    setTotal,
    offset = 0,
    limit = 10,
    searchFilter = ""
  ) => {
    try {
      const params = {};
      if (searchFilter && searchFilter.trim()) {
        params.searchFilter = searchFilter.trim();
      }
      const response = await Apis.getServices(offset, limit, params);
      if (response?.status === 200) {
        setServiceData(response.data.data ?? []);
        const totalRecords =
          response.data.pagination?.totalRecords ??
          response.data.totalCount ??
          response.data.data?.length ??
          0;
        setTotal(totalRecords);
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Failed to fetch services.");
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      throw error;
    }
  }, []);

  const searchServices = useCallback(async (searchFilter, offset = 0, limit = 10) => {
    try {
      const params = {};
      if (searchFilter && searchFilter.trim()) {
        params.searchFilter = searchFilter.trim();
      }
      const response = await Apis.getServices(offset, limit, params);
      return response.data;
    } catch (error) {
      console.error("Error searching services:", error);
      throw error;
    }
  }, []);

  const addService = useCallback(async (data) => {
    try {
      const response = await Apis.addService(data);
      return response.data;
    } catch (error) {
      console.error("Error adding service:", error);
      throw error;
    }
  }, []);

  const updateService = useCallback(async (id, data) => {
    try {
      const response = await Apis.updateService(id, data);
      return response.data;
    } catch (error) {
      console.error("Error updating service:", error);
      throw error;
    }
  }, []);

  const deleteService = useCallback(async (id) => {
    try {
      const response = await Apis.deleteService(id);
      return response.data;
    } catch (error) {
      console.error("Error deleting service:", error);
      throw error;
    }
  }, []);

  const getServiceById = useCallback(async (id, setServiceData) => {
    try {
      const response = await Apis.getServiceById(id);
      const service = response.data?.data ?? response.data;
      setServiceData(service);
      return service;
    } catch (error) {
      console.error("Error fetching service by id:", error);
      throw error;
    }
  }, []);

  const addServiceCategory = useCallback(async (data) => {
    try {
      setLoading(true);
      const response = await Apis.addServiceCategory(data);
      return response?.data;
    } finally {
      setLoading(false);
    }
  }, []);

  const updateServiceCategory = useCallback(async (id, data) => {
    try {
      setLoading(true);
      const response = await Apis.updateServiceCategory(id, data);
      return response?.data;
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteServiceCategory = useCallback(async (id) => {
    try {
      setLoading(true);
      const response = await Apis.deleteServiceCategory(id);
      return response?.data;
    } finally {
      setLoading(false);
    }
  }, []);

  const getServicesCategories = useCallback(async (
    setCategories,
    setTotal,
    offset = 0,
    limit = 10,
    name = "",
  ) => {
    try {
      setLoading(true);
      const params = {};
      if (name && name.trim()) params.name = name.trim();

      const response = await Apis.getServicesCategories(offset, limit, params);
      if (response?.status === 200) {
        setCategories(response.data.data ?? []);
        setTotal(response.data.totalCount ?? 0);
        return response.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch services categories.");
    } finally {
      setLoading(false);
    }
  }, []);

  const searchServicesCategories = useCallback(async (name, offset = 0, limit = 10) => {
    const params = {};
    if (name && name.trim()) params.name = name.trim();

    const response = await Apis.getServicesCategories(offset, limit, params);
    return response.data;
  }, []);

  const getServiceCategoriesForSelect = useCallback(async (setCategories) => {
    try {
      const response = await Apis.getServicesCategoriesForSelect();
      const categories = response?.data?.data ?? [];
      if (setCategories && typeof setCategories === "function") {
        setCategories(categories);
      }
      return categories;
    } catch (error) {
      console.error("Error fetching service categories:", error);
      throw error;
    }
  }, []);

  return {
    loading,
    getServices,
    searchServices,
    addService,
    updateService,
    deleteService,
    getServiceById,
    addServiceCategory,
    updateServiceCategory,
    deleteServiceCategory,
    getServicesCategories,
    searchServicesCategories,
    getServiceCategoriesForSelect,
  };
};
